module.exports = __webpack_public_path__ + "img/memberships.90d120c0.svg";